<template>
  <div>
    <div class="mb-4">
      <h6 class="text-base inline-block">Line Items</h6>
      &nbsp;
      <a role="button" class="inline-block" @click="addLine"> Add Line </a>
    </div>
    <div class="grid gap-y-1">
      <OfferLineHeaderItem />

      <OfferLineItem
        v-for="(lineItem, idx) in offerLines"
        :key="`line_item_${idx}`"
        :num="idx"
        :description.sync="lineItem.description"
        :quantity.sync="lineItem.quantity"
        :price-per-unit.sync="lineItem.pricePerUnit"
        :net-amount.sync="lineItem.netAmount"
        :vat-rate.sync="lineItem.vatRate"
        :vat-amount.sync="lineItem.vatAmount"
        :total.sync="lineItem.total"
        :disabled="disabled"
        @offer-line-item:remove="removeLine(idx)"
      />

      <OfferLineFooterItem :line-items="offerLines" />
    </div>
  </div>
</template>

<script>
import OfferLineItemVue from './OfferLineItem.vue';
import OfferLineHeaderItemVue from './OfferLineHeaderItem.vue';
import OfferLineFooterItemVue from './OfferLineFooterItem.vue';

const DEFAULT_LINE_ITEM = {
  description: '',
  quantity: 1,
  pricePerUnit: 0,
  netAmount: 0,
  vatRate: 0.24,
  vatAmount: 0,
  total: 0,
};
export default {
  components: {
    OfferLineHeaderItem: OfferLineHeaderItemVue,
    OfferLineItem: OfferLineItemVue,
    OfferLineFooterItem: OfferLineFooterItemVue,
  },

  props: {
    offerLines: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
  },

  data() {
    return {
      data: [
        //
      ],
    };
  },

  methods: {
    addLine() {
      this.$emit('update:offer-lines', [...this.offerLines, { ...DEFAULT_LINE_ITEM }]);
    },
    removeLine(removedIndex) {
      this.$emit('update:offer-lines', [
        ...this.offerLines.filter((line, index) => index !== removedIndex),
      ]);
    },
  },
};
</script>
